module.exports = __webpack_public_path__ + "static/media/0024_IMG_LE_FROMAGER_FE.261676e7.png";